! ( function ( e ) {
	var n,
		t = function ( e ) {
			n = 'mousedown' === e.type;
		},
		o = function ( e ) {
			n && e.target.classList.add( 'focus--mouse' );
		},
		s = function ( e ) {
			e.target.classList.remove( 'focus--mouse' );
		},
		d = function () {
			e.addEventListener( 'keydown', t ),
				e.addEventListener( 'mousedown', t ),
				e.addEventListener( 'focusin', o ),
				e.addEventListener( 'focusout', s );
		};
	d();
} )( document.body );
